module.exports = __webpack_public_path__ + "img/ctrl-p-stub-up-+i.2ddd3cc4.svg";